module.exports = __webpack_public_path__ + "img/location.b47c1973.svg";